export var CHANGE_LOCALE = 'CHANGE_LOCALE';



// WEBPACK FOOTER //
// ./src/actions/locale.js